const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// Store token in localStorage
export const setToken = (token) => {
  localStorage.setItem('authToken', token);
};

// Get token from localStorage
export const getToken = () => {
  return localStorage.getItem('authToken');
};

// Remove token from localStorage
export const removeToken = () => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('user');
};

// Store user data
export const setUser = (user) => {
  localStorage.setItem('user', JSON.stringify(user));
};

// Get user data
export const getUser = () => {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
};

// Check if user is authenticated
export const isAuthenticated = () => {
  return !!getToken();
};

// Login function
export const login = async (username, password) => {
  try {
    const response = await fetch(`${API_URL}/api/auth/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ username, password }),
    });

    const data = await response.json();

    if (data.success) {
      setToken(data.token);
      setUser(data.user);
      return { success: true, user: data.user };
    } else {
      return { success: false, message: data.message || 'Login failed' };
    }
  } catch (error) {
    console.error('Login error:', error);
    return { success: false, message: 'Network error. Please try again.' };
  }
};

// Verify token
export const verifyToken = async () => {
  try {
    const token = getToken();
    if (!token) return false;

    const response = await fetch(`${API_URL}/api/auth/verify`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    const data = await response.json();
    
    if (data.success) {
      setUser(data.user);
      return true;
    } else {
      removeToken();
      return false;
    }
  } catch (error) {
    console.error('Token verification error:', error);
    removeToken();
    return false;
  }
};

// Logout function
export const logout = async () => {
  removeToken();
};

// Authenticated fetch wrapper
export const authFetch = async (url, options = {}) => {
  const token = getToken();
  
  const defaultHeaders = {
    'Content-Type': 'application/json',
  };

  if (token) {
    defaultHeaders['Authorization'] = `Bearer ${token}`;
  }

  const config = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
  };

  try {
    const response = await fetch(`${API_URL}${url}`, config);
    
    // If unauthorized, logout user
    if (response.status === 401) {
      removeToken();
      window.location.href = '/admin/login';
      return null;
    }

    return response;
  } catch (error) {
    console.error('API request error:', error);
    throw error;
  }
};

// Upload file with auth
export const uploadFile = async (file, type = 'image') => {
  try {
    const formData = new FormData();
    formData.append(type, file);

    const token = getToken();
    const response = await fetch(`${API_URL}/api/upload/${type}`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
      body: formData,
    });

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('File upload error:', error);
    throw error;
  }
};

const authUtils = {
  login,
  logout,
  verifyToken,
  isAuthenticated,
  getUser,
  setUser,
  getToken,
  setToken,
  removeToken,
  authFetch,
  uploadFile,
};

export default authUtils;